import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import EmptyContentPanel from '../../../shared/EmptyContentPanel';

import './BorrowingEmptyContentPanel.scss';

export default function BorrowingEmptyContentPanel({ className, title, subtitle, icon, showExploreNewTitlesLink, fetching }) {
  return (
    <div className={cn('cp-borrowing-empty-content-panel', className)}>
      <EmptyContentPanel
        icon={icon}
        title={title}
        subtitle={subtitle}
        fetching={fetching}>

        {showExploreNewTitlesLink && (
          <a
            className="cp-explore-new-titles-link"
            href="/explore/recent_arrivals">
            <FormattedMessage id="explore_new_titles" />
          </a>
        )}
      </EmptyContentPanel>
    </div>
  );
}

BorrowingEmptyContentPanel.defaultProps = {
  showExploreNewTitlesLink: false
};

BorrowingEmptyContentPanel.propTypes = {
  className: PropTypes.string,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  icon: PropTypes.node,
  showExploreNewTitlesLink: PropTypes.bool,
  fetching: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingEmptyContentPanel/BorrowingEmptyContentPanel.jsx